import React, { ComponentPropsWithRef } from "react";

import "./logo.css";
import { TransparentButton } from "../transparent-button";

export const Logo = ({
	html,
	...buttonProps
}: ComponentPropsWithRef<"button"> & {
	html: string;
}) => (
	<TransparentButton className="logo" type="button" {...buttonProps}>
		<span dangerouslySetInnerHTML={{ __html: html }} />
	</TransparentButton>
);
Logo.displayName = "Logo";
